export const MORE_COLLECTIONS_ROUTE = '/learn/collections';
export const COLLECTIONS_ROUTE = '/learn/collections';
